export const yellow = {
    logo:'#fcce06'
}

export const gray = {
    default:'#353230',
    bg:'#ebebeb'
}